import type { TopicResponseAuth } from './topicResponseAuth';
import type { TopicResponseBasicInfo } from './topicResponseBasicInfo';
import type { TopicResponseDetails } from './topicResponseDetails';
import type { TopicResponseMedia } from './topicResponseMedia';

export interface TopicResponse {
  /** 인증 컨텍스트 정보 */
  auth?: TopicResponseAuth;
  basicInfo?: TopicResponseBasicInfo;
  /** 토픽 상세 정보 */
  details?: TopicResponseDetails;
  /** 미디어 정보 */
  media?: TopicResponseMedia;
}
